import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Bots from '@/pages/Bots';
import TradingPro from '@/pages/TradingPro';
import Arbitrage from '@/pages/Arbitrage';
import News from '@/pages/News';
import LiveData from '@/pages/LiveData';
import Cuenta from '@/pages/Cuenta';
import CopyTrading from '@/pages/CopyTrading';
import History from '@/pages/History';
import IA from '@/pages/IA';
import AteneaTrader from '@/pages/AteneaTrader';
import Scanner from '@/pages/Scanner';
import { LanguageProvider } from '@/contexts/LanguageContext';
import Settings from '@/pages/Settings';
import KYC from '@/pages/KYC';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import KycGate from '@/components/KycGate';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="text-center"><div className="aegis-spinner mx-auto"></div><p className="text-[#A1A1AA] text-sm mt-3">Cargando...</p></div>
      </div>
    );
  }

  if (!user && !location.state?.user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><KycGate><Dashboard /></KycGate></ProtectedRoute>} />
      <Route path="/bots" element={<ProtectedRoute><KycGate><Bots /></KycGate></ProtectedRoute>} />
      <Route path="/trading" element={<ProtectedRoute><KycGate><TradingPro /></KycGate></ProtectedRoute>} />
      <Route path="/arbitrage" element={<ProtectedRoute><KycGate><Arbitrage /></KycGate></ProtectedRoute>} />
      <Route path="/news" element={<ProtectedRoute><KycGate><News /></KycGate></ProtectedRoute>} />
      <Route path="/ia" element={<ProtectedRoute><KycGate><IA /></KycGate></ProtectedRoute>} />
      <Route path="/atenea-trader" element={<ProtectedRoute><KycGate><AteneaTrader /></KycGate></ProtectedRoute>} />
      <Route path="/copy-trading" element={<ProtectedRoute><KycGate><CopyTrading /></KycGate></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><KycGate><History /></KycGate></ProtectedRoute>} />
      <Route path="/cuenta" element={<ProtectedRoute><KycGate><Cuenta /></KycGate></ProtectedRoute>} />
      <Route path="/scanner" element={<ProtectedRoute><KycGate><Scanner /></KycGate></ProtectedRoute>} />
      <Route path="/livedata" element={<ProtectedRoute><KycGate><LiveData /></KycGate></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><KycGate><Settings /></KycGate></ProtectedRoute>} />
      <Route path="/kyc" element={<ProtectedRoute><KYC /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><KycGate><AdminDashboard /></KycGate></ProtectedRoute>} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;